module.exports = __webpack_public_path__ + "static/img/staff1.a8a4352a.svg";